import script from "./ProfileForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileForm.vue?vue&type=script&setup=true&lang=js"

import "./ProfileForm.vue?vue&type=style&index=0&id=95e2dcec&lang=scss"

const __exports__ = script;

export default __exports__